let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5DqrE")).then(() => parcelRequire('3zytW'));